import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true // 👈 necessário para enviar cookies // deixar relativo para o Vite redirecionar
});

// Interceptor para respostas
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const rotaAtual = window.location.pathname;

    // Lista de rotas que não devem passar pelo refresh
    const rotasIgnoradas = ["/login"];

    if (rotasIgnoradas.includes(rotaAtual)) {
      return Promise.reject(error); // não tenta refresh
    }


     // ⚠️ Se a rota que falhou foi o /auth/refresh, não tenta de novo
    if (originalRequest.url.includes("/auth/refresh")) {
      console.error("❌ Refresh falhou, redirecionando para login");

      // limpa tokens/cookies se precisar
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");

      window.location.href = "/login";
      return Promise.reject(error);
    }


    // Se deu 401/403 e ainda não tentamos refresh
    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        // tenta renovar
        await api.post("/auth/refresh");

        // repete a requisição original
        return api(originalRequest);
      } catch (err) {
        console.error("❌ Refresh falhou, redirecionando para login");

        window.location.href = "/login";

        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
